// extracted by mini-css-extract-plugin
export default {"svg":"fDpg3xtNAxDI2b3OGpP3"};